import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {RegionModel} from '../../../@models/region';
import {CompleterData, CompleterItem, CompleterService} from 'ng2-completer';
import {ApiService} from '../../../@core/service/api.service';

@Component({
  selector: 'ngx-form-region',
  templateUrl: './form-region.component.html',
  styleUrls: ['./form-region.component.scss'],
})
export class FormRegionComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() value: RegionModel;
  @Input() enabled: boolean = true;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  regionName: string;

  regionService: CompleterData;

  constructor(private api: ApiService, private completerService: CompleterService) {
    this.regionService = completerService.local(api.reloadRegions(), 'name', 'name');

  }

  ngOnInit() {
    if (this.value != null) {
      this.regionName = this.value.name;
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value.currentValue != null)
      this.regionName = changes.value.currentValue.name;
  }
  select(item: CompleterItem): void {
    this.valueChange.emit(item.originalObject);
  }



}
